import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import moment from 'moment'
import AuthService from './services/authService'

const authService = new AuthService()
authService.start()

// Add a request interceptor to renew auth token
axios.interceptors.request.use(function (config) {
  return new Promise((resolve, reject) => {
    if (authService.isAccessTokenExpired()) {
      console.log('Access token expired, refreshing...')
      authService
        .refreshSession()
        .then((authResult) => {
          console.log('Auth result', authResult)
          config.headers['Authorization'] = `Bearer ${authResult.accessToken}`
          resolve(config)
        })
        .catch((err) => {
          console.error('Unable to refresh token', err)
          reject(err)
          router.push('/login')
        })
    }
    else {
      config.headers['Authorization'] = `Bearer ${authService.getAccessToken()}`
      resolve(config)
    }
  })
}, function (error) {
  // Do something with request error
  return Promise.reject(error)
})

Vue.prototype.$authService = authService
Vue.prototype.$moment = moment
Vue.config.productionTip = false
Vue.use(BootstrapVue)

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@mdi/font/css/materialdesignicons.min.css'
import '@/assets/css/app.scss'

new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
